<script setup>
const articlesStore = useArticlesStore();
const route = useRoute();
const { t } = useI18n();

const { data: articleData, error: articleError } = await useAsyncData(() =>
  articlesStore.fetchArticle(route.params.articleSlug),
);

if (articleError.value) {
  const { statusCode, statusMessage } = articleError.value;
  throw createError({ statusCode, statusMessage, fatal: true });
}

useHead({
  title: `${articleData.value.title} | ${t('pressCenter.meta.title')}`,
  meta: [
    {
      name: 'description',
      content: `${articleData.value.title}. ${t('pressCenter.meta.description')}`,
    },
  ],
});
</script>

<template>
  <div class="pages-press-center-details-article-slug">
    <BundlesHead
      :title="$t('pressCenter.singleArticle.title')"
      :subtitle="articleData.title"
      :caption="useFormatDate(articleData.publishedAt)"
      :back-text="$t('pressCenter.singleArticle.back')"
      back-url="/press-center"
    />

    <CtrSidebar v-if="articleData.text">
      <template #content>
        <CtrText in-sidebar :text="articleData.text" />
      </template>
    </CtrSidebar>
  </div>
</template>

<style scoped lang="scss">
.pages-press-center-details-article-slug {
  padding-top: em($gap-page-title);
  padding-bottom: em(180);

  @include media-breakpoint-down(sm) {
    padding-top: em($gap-page-title-sm);
    padding-bottom: em(95);
  }
}
</style>
